import { render, staticRenderFns } from "./SideNav.vue?vue&type=template&id=21561c2c&scoped=true&"
import script from "./SideNav.vue?vue&type=script&setup=true&lang=js&"
export * from "./SideNav.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SideNav.vue?vue&type=style&index=0&id=21561c2c&prod&lang=css&"
import style1 from "./SideNav.vue?vue&type=style&index=1&id=21561c2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21561c2c",
  null
  
)

export default component.exports